import { motion } from "framer-motion";
import { ArrowRight, Box } from "lucide-react";
import { RESEARCH_BOXES } from "@/data/products";
import { scrollToId } from "@/hooks/useLenis";
import { useLang } from "@/i18n/LanguageContext";
import { boxText } from "@/i18n/translations";
import { reveal } from "@/hooks/reveal";

export const ResearchBox = ({ onInquire }) => {
  const { t, lang } = useLang();
  const request = () => {
    onInquire?.("Custom Research Box Configuration");
    scrollToId("contact");
  };

  return (
    <section id="research-box" className="relative bg-black/40 py-24 md:py-32 overflow-hidden" data-testid="research-box-section">
      <div className="absolute inset-0 spotlight opacity-60" />
      <div className="relative max-w-[1500px] mx-auto px-6 md:px-10">
        {/* Header */}
        <motion.div className="max-w-3xl" {...reveal()}>
          <span className="font-mono-tech text-[11px] tracking-[0.35em] uppercase text-[var(--al-gold)]">
            {t.researchBox.eyebrow}
          </span>
          <h2 className="font-cinzel font-bold text-white text-3xl sm:text-4xl lg:text-5xl mt-4 leading-[1.08]">
            {t.researchBox.title}
          </h2>
          <p className="font-body text-white/55 text-sm md:text-base leading-relaxed mt-6">
            {t.researchBox.intro}
          </p>
        </motion.div>

        {/* Configs grid */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {RESEARCH_BOXES.map((box, i) => {
            const bt = boxText(lang, box.id);
            return (
            <motion.div
              key={box.id}
              {...reveal(i * 0.1)}
              className="vial-card group flex flex-col border border-white/[0.08] bg-[#0e0e0e] p-6 md:p-7"
              data-testid={`research-box-config-${box.id}`}
            >
              <div className="w-11 h-11 border border-[var(--al-gold)]/30 flex items-center justify-center">
                <Box className="w-5 h-5 text-[var(--al-gold)]" />
              </div>
              <h4 className="font-display font-bold text-white text-xl tracking-tight mt-5">{bt.name}</h4>
              <p className="font-body text-white/50 text-[13px] leading-relaxed mt-2 flex-1">{bt.desc}</p>
              <div className="flex flex-wrap gap-2 mt-4">
                {box.tags.map((tag) => (
                  <span key={tag} className="font-mono-tech text-[10px] tracking-wide text-white/60 border border-white/10 px-2 py-1">
                    {tag}
                  </span>
                ))}
              </div>
            </motion.div>
            );
          })}
        </div>

        <motion.button
          {...reveal()}
          onClick={request}
          className="btn-gold mt-12 inline-flex border border-[var(--al-gold)] px-8 py-4 font-body text-[12px] tracking-[0.2em] uppercase text-[var(--al-gold)]"
          data-testid="request-custom-box-btn"
        >
          <span className="flex items-center gap-2">
            {t.researchBox.requestBtn}
            <ArrowRight className="w-4 h-4" />
          </span>
        </motion.button>
      </div>
    </section>
  );
};
